import { render, staticRenderFns } from "./RecursiveDown.vue?vue&type=template&id=6c905d25&"
import script from "./RecursiveDown.vue?vue&type=script&lang=js&"
export * from "./RecursiveDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports